import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@lt/components';

import { i18n } from '@lt/localization';
import TouristField from '../../TouristField';
import { TouristDateField } from '../index';
import {
  DOC_TYPES,
  INPUT_PATTERN,
} from '../../../../routes/Checkout/store/constants/tourists';
import { NATIONALITY_CONSTANTS } from '../../../../constants';
import { CHANGING_DAYS_LIMIT } from '../../contstants';

import styles from './touristDocument.module.css';

class TouristDocument extends React.PureComponent {
  constructor(props) {
    super(props);
    this.toggleInput = this.toggleInput.bind(this);
  }

  get numberField() {
    const { docType, nationality_id } = this.props;

    if (nationality_id === NATIONALITY_CONSTANTS.RU) {
      const { numberField } = DOC_TYPES[docType];
      return numberField;
    }
    return null;
  }

  get placeholder() {
    const field = this.numberField;
    return field && field.placeholder;
  }

  get mask() {
    const field = this.numberField;
    return field && field.mask;
  }

  get docsLaterText() {
    const { docType } = this.props;
    const { dateField } = DOC_TYPES[docType];
    return (
      <div>
        {i18n.t('checkout.touristForm.document.later', {
          context: dateField ? '' : 'phone',
          changeDay: CHANGING_DAYS_LIMIT,
        })}
      </div>
    );
  }

  get pattern() {
    const { nationality_id } = this.props;
    if (nationality_id === NATIONALITY_CONSTANTS.RU) {
      return null;
    }

    return INPUT_PATTERN.EXCLUDE_SCRIPT;
  }

  toggleInput() {
    const { hideInput, onHideInput } = this.props;
    onHideInput(!hideInput);
  }

  render() {
    const {
      docType,
      hideInput,
      number,
      date,
      onNumberChange,
      onDateChange,
      allowDocsLater,
      nationality_id,
      ...others
    } = this.props;

    if (!docType) {
      return null;
    }
    const { dateField, name: docName, id } = DOC_TYPES[docType];

    const showBirthCertificate =
      nationality_id === NATIONALITY_CONSTANTS.RU && id === 'birth_certificate';

    const tooltipText = showBirthCertificate
      ? i18n.t('checkout.touristForm.showBirthCertificate')
      : null;

    return (
      <div className={styles.container}>
        {hideInput ? (
          <span>{this.docsLaterText}</span>
        ) : (
          <div className={styles.fields}>
            <TouristField
              {...others}
              value={number}
              mask={this.mask}
              placeholder={this.placeholder}
              inputmode={this.mask ? 'numeric' : null}
              onChange={onNumberChange}
              label={i18n.t('checkout.touristForm.document.number')}
              stateField="passport_number"
              pattern={this.pattern}
              preventWrongInput
              tooltipText={tooltipText}
              formatBirthCertificate={showBirthCertificate}
              fieldType="number"
            />
            {dateField && (
              <TouristDateField
                {...others}
                value={date}
                onChange={onDateChange}
                label={dateField.name}
                stateField={dateField.id}
                fieldType="date"
              />
            )}
          </div>
        )}
        {allowDocsLater && (
          <div>
            <Button
              functional
              className={styles.button}
              onClick={this.toggleInput}
            >
              {i18n.t('checkout.touristForm.document.input', {
                context: hideInput ? 'now' : 'later',
                docName: dateField ? docName : '',
              })}
            </Button>
          </div>
        )}
      </div>
    );
  }
}

TouristDocument.defaultProps = {
  docType: null,
  number: null,
  date: null,
  hideInput: false,
  maskAllowed: false,
  allowDocsLater: false,
};

TouristDocument.propTypes = {
  docType: PropTypes.oneOf(Object.keys(DOC_TYPES)),
  number: PropTypes.string,
  date: PropTypes.string,
  hideInput: PropTypes.bool,
  maskAllowed: PropTypes.bool,
  allowDocsLater: PropTypes.bool,
  onHideInput: PropTypes.func.isRequired,
  onNumberChange: PropTypes.func.isRequired,
  onDateChange: PropTypes.func.isRequired,
};

export default TouristDocument;
